exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\r\n\r\n.spinner_container_-o2Vc {\r\n    display: flex;\r\n    width: 100%;\r\n    height: 100%;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.spinner_spinner_2EFkd {\r\n    width: 64px;\r\n    height: 64px;\r\n    border-radius: 50%;\r\n    border: 6px solid;\r\n    border-color: var(--looks-secondary) transparent var(--looks-secondary) transparent;\r\n    animation: spinner_spinner_2EFkd 1.2s linear infinite;\r\n}\r\n\r\n@keyframes spinner_spinner_2EFkd {\r\n    0% {\r\n        transform: rotate(0deg);\r\n    }\r\n    100% {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "spinner_container_-o2Vc",
	"spinner": "spinner_spinner_2EFkd"
};